/**
 * @generated SignedSource<<915ccfdb9827d09de26f82508c5f645f>>
 * @relayHash 2bdfda8629ba5a2d466e6b228eac05f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84853bbd61f0143a528d0dd13ec13ee60706a3d15a2cac4b13e1aa281a49740d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "84853bbd61f0143a528d0dd13ec13ee60706a3d15a2cac4b13e1aa281a49740d",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
